import axios from 'axios'

const API_URL = process.env.REACT_APP_API_V2_URL
const signS3 = (data: any): Promise<any | undefined> => {
  return axios.post(`${API_URL}/sign_s3`, data)
}

export {signS3}
